module.exports = __webpack_public_path__ + "static/media/wsymbol_0021_cloudy_with_sleet_big_s1.708d4dc2.png";